import { Divider, Skeleton, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { useTranslation } from 'react-i18next';
import ConditionalWrapper from '../ConditionalWrapper/ConditionalWrapper';
import { ImageItem } from '../Cards/Types';
import Pagination from '../Pagination/Pagination';
import Sorting from '../Sorting/Sorting';
import { TagItem } from '../Tag/types';
import ImageCards from '../Cards/ImageCards';
import ImageDashBoardSkeleton from '../Skeletons/ImageDashBoardSkeleton';


interface CardGridProps {
    Grid?: JSX.Element,
    sorting?: {
        defaultValue: string | undefined;
        handleSortingChange: (value: string) => void;
        sortingItems: any;
        clientSideSorting: boolean
    },
    isLoading: boolean;
    pagination?: {
        itemsPerPage: number;
        totalResults: number;
        selectedPage: number;
        handleOnPageChange: (value: number) => void;
        serverSidePagination: boolean
    },
    grid: {
        gridData: ImageItem[];
        onTagClick?: any;
        onSubmitFavorite?: any
        selectedTags?: TagItem[]
        onChangeRegistration?: any
    };
}
function CardGrid(props: CardGridProps) {
  
  const { t } = useTranslation();
  const { sorting = {
    defaultValue: '',
    handleSortingChange: () => undefined,
    sortingItems: [] 
  },
  isLoading,
  pagination = {
    handleOnPageChange: () => undefined,
    itemsPerPage: 3,
    selectedPage: 1,
    totalResults: 10
  },
  grid
  } = props;

  const { defaultValue,
    handleSortingChange,
    sortingItems 
  } = sorting;

  const { handleOnPageChange,
    itemsPerPage,
    selectedPage,
    totalResults: totalPages 
  } = pagination;

  const { gridData, 
    onTagClick: gridHandleOnChange, 
    onSubmitFavorite,
    onChangeRegistration,
    selectedTags
  } = grid;

  const { Grid = <ImageCards
    isLoading={isLoading}
    imageData={gridData}
    onChangeRegistration={onChangeRegistration}
    onTagClick={gridHandleOnChange}
    onSubmitFavorite={onSubmitFavorite}
    selectedTags={selectedTags}
  /> } = props;

  return (<>
    <ConditionalWrapper condition={isLoading} 
      wrapper={(children) => <Skeleton variant='rectangular' 
        sx={{marginLeft: 'auto', borderRadius: '25px', maxWidth: '222px', maxHeight: '56px'}}>{children}</Skeleton>}>
      <Sorting defaultValue={defaultValue} onChange={(value) => handleSortingChange(value)}
        sortingItems={sortingItems}
      />
    </ConditionalWrapper> 
    <Divider sx={{ mt: 2, mb: 2 }} />

    <Box display='flex' justifyContent='flex-start'>
      <Box id='results-container' 
     
        width='100%'>
        {
          gridData.length == 0 && isLoading
            ? <ImageDashBoardSkeleton noItems={8} />
            : gridData.length ?
              { ...Grid }
              : <Box display='flex' justifyContent='center'>
                <Typography variant='h2'>{t('Δεν βρέθηκαν αποτελέσματα')}
                </Typography>
              </Box>
        }
        <Divider sx={{ mt: 2, mb: 2 }} />
        <Pagination
          itemsPerPage={itemsPerPage}
          totalItems={totalPages}
          currentPage={selectedPage}
          onPageChange={handleOnPageChange}
        />
      </Box>
    </Box>
    

  </>
  );
}

export default CardGrid;